export default __webpack_public_path__ + "static/media/done.c843f2b7.svg";